var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAlphabetSortDesc = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_811_52141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.62734 16C4.29614 16 4.02734 15.7313 4.02734 15.4V0.6C4.02734 0.268799 4.29614 0 4.62734 0C4.95854 0 5.22734 0.268799 5.22734 0.6V15.4C5.22734 15.7313 4.95854 16 4.62734 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.62256 15.9999C4.4689 15.9999 4.31523 15.9415 4.19849 15.8238L1.39844 13.0239C1.16406 12.7894 1.16406 12.4094 1.39844 12.175C1.63296 11.9407 2.01294 11.9407 2.24731 12.175L4.62329 14.551L6.99927 12.175C7.23364 11.9407 7.61377 11.9407 7.84814 12.175C8.08252 12.4094 8.08252 12.7894 7.84814 13.0239L5.0481 15.8238C4.92974 15.9415 4.77607 15.9999 4.62256 15.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2248 6.40005H11.4247C11.2135 6.40005 11.0175 6.28887 10.9095 6.10796C10.8007 5.92646 10.7958 5.70161 10.8959 5.51602L13.2191 1.2H11.4247C11.0935 1.2 10.8247 0.931201 10.8247 0.6C10.8247 0.268799 11.0935 0 11.4247 0H14.2248C14.4358 0 14.6318 0.111182 14.7399 0.291943C14.8486 0.473584 14.8535 0.698437 14.7536 0.884033L12.4294 5.20005H14.2248C14.556 5.20005 14.8247 5.46885 14.8247 5.80005C14.8247 6.13125 14.556 6.40005 14.2248 6.40005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6243 15.2002C13.6243 15.5314 13.8931 15.8002 14.2243 15.8002C14.5555 15.8002 14.8243 15.5314 14.8243 15.2002V13.0001V11.4001C14.8243 10.2969 13.9273 9.40015 12.8242 9.40015C11.721 9.40015 10.8242 10.2969 10.8242 11.4001V13.0001V15.2002C10.8242 15.5314 11.093 15.8002 11.4242 15.8002C11.7554 15.8002 12.0242 15.5314 12.0242 15.2002V13.6001H13.6243V15.2002ZM13.6243 12.4001V11.4001C13.6243 10.9586 13.2658 10.6001 12.8242 10.6001C12.3827 10.6001 12.0242 10.9586 12.0242 11.4001V12.4001H13.6243Z",
    fill: "white",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_811_52141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlphabetSortDesc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alphabet-sort-desc.6d51c06b.svg";
export { ForwardRef as ReactComponent };